import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/app.materials';
import {PageMeta} from "../../../../../../shared/models/page.model";

@Component({
  selector: 'app-new-portfolio-search',
  templateUrl: './new-portfolio-search.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, MaterialModule]
})
export class NewPortfolioSearchComponent implements OnInit {

  @Input() model: any;

  @Output() modelChange = new EventEmitter<any>();

  @Output() fetchCompanies: EventEmitter<any> = new EventEmitter<any>();

  @Input() meta: PageMeta;

  constructor() {
  }

  onFetchCompanies() {
    this.fetchCompanies.emit();
  }

  ngOnInit(): void {
  }

}
